module.exports = __webpack_public_path__ + "static/media/icon_econometrica.eaa9753b.svg";